import './_blog-article-card.scss';
import component from './blog-article-card';

export default component;
